<template>
  <div class="documents-report-table">
    <loader
      v-if="loading"
      class="documents-report-table__loader"
      :class="{
        cover: workers.length,
      }"
      :active="loading"
      label="Данные загружаются"
      height="300"
    ></loader>

    <horizontal-table
      v-if="workers.length"
      :fix-header="true"
      class="documents-report-table__table"
      @nextPage="$emit('nextPage')"
    >
      <table class="h-table" :fix-header="true">
        <tbody>
          <tr>
            <th>ФИО</th>

            <td v-for="worker in workers" :key="worker.id">
              <router-link
                :to="{
                  name: 'personal-employee-documents',
                  params: { id: worker.id },
                }"
              >
                {{ worker.name }}
              </router-link>
            </td>
          </tr>

          <tr>
            <th>Дата приема сотрудника</th>

            <td v-for="worker in workers" :key="worker.id">
              {{ worker.hiringDate }}
            </td>
          </tr>

          <tr>
            <th>Филиал</th>

            <td v-for="worker in workers" :key="worker.id">
              {{ worker.filial }}
            </td>
          </tr>

          <tr>
            <th>Должность</th>

            <td v-for="worker in workers" :key="worker.id">
              <div v-for="(position, index) in worker.positions" :key="position+worker.id+index">
                {{ position }}
              </div>
            </td>
          </tr>

          <tr>
            <th>Гражданство</th>

            <td v-for="worker in workers" :key="worker.id">
              {{ worker.citizenship }}
            </td>
          </tr>

          <tr>
            <th>Правовой статус</th>

            <td v-for="worker in workers" :key="worker.id">
              {{ worker.lawStatus }}
            </td>
          </tr>
        </tbody>

        <template v-for="group in docGroups">
          <tr :key="group.id + '-header'" class="documents-group">
            <th>
              <div class="title">
                {{ group.name }}
                <div v-b-toggle="'group-toggler-' + group.id" class="toggler">
                  <svg-icon name="chevron-top-circled" :size="22" color="primary" class="toggler-icon"></svg-icon>
                </div>
              </div>
            </th>

            <td v-for="worker in workers" :key="worker.id"></td>
          </tr>

          <b-collapse
            :id="'group-toggler-' + group.id"
            :key="group.id + '-items'"
            tag="tbody"
            class="documents-group-items"
          >
            <tr v-for="doc in group.documents" :key="group.id + '-doc-' + doc.id" class="documents-item">
              <th>
                <span>{{ doc.name }}</span>
              </th>

              <document-status
                v-for="worker in workers"
                :key="worker.id"
                :worker="worker"
                :group-id="group.id"
                :document-id="doc.id"
              />
            </tr>
          </b-collapse>
        </template>
      </table>
    </horizontal-table>

    <div v-if="inited && !loading && !workers.length" class="documents-report-table__empty">
      Ничего не найдено. Попробуйте изменить параметры поиска.
    </div>
  </div>
</template>

<script>
import HorizontalTable from "@/components/horizontal-table";
import Loader from "@/components/loader";
import SvgIcon from "@/components/svg-icon";
import DocumentStatus from "./document-status";

export default {
  name: "documents-report-table",

  components: {
    HorizontalTable,
    Loader,
    SvgIcon,
    DocumentStatus,
  },

  props: ["workers", "loading", "inited"],

  computed: {
    docGroups() {
      const { workers } = this;
      if (!workers.length) return [];
      const worker = workers[0];
      return worker.docGroups;
    },
  },
};
</script>

<style lang="scss" scoped src="./style.scss"></style>
